import { HttpBackend, HttpClient } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import { Country } from '../../model/country.model';
import { catchError, Observable, of } from 'rxjs';
import { NGXLogger } from 'ngx-logger';

@Service()
export class CountriesService {
  #httpBackend: HttpClient;
  #handler = inject(HttpBackend);
  #logger = inject(NGXLogger);

  constructor() {
    this.#httpBackend = new HttpClient(this.#handler);
  }

  #countriesJson = '/assets/data/countries.json';
  #languagesJson = '/assets/data/languages.json';

  public getCountries(): Observable<Country[]> {
    return this.#httpBackend.get<Country[]>(this.#countriesJson, { responseType: 'json' }).pipe(
      catchError((error) => {
        this.#logger.error('Error fetching countries:', error);
        return of([] as Country[]);
      }),
    );
  }
  public getLanguages(): Observable<string[]> {
    return this.#httpBackend.get<string[]>(this.#languagesJson, { responseType: 'json' }).pipe(
      catchError((error) => {
        this.#logger.error('Error fetching languages:', error);
        return of([] as string[]);
      }),
    );
  }
}
